module.exports = __webpack_public_path__ + "img/logo-header.d6cfd4b8.png";